export type SoundAssetKind = 'music' | 'ambience' | 'sfx';

export interface SoundAssetDefinition {
  readonly key: string;
  readonly path: string;
  readonly kind: SoundAssetKind;
  readonly volume?: number;
}

export interface WorldSoundscapeDefinition {
  readonly id: string;
  readonly musicKey?: string;
  readonly ambienceKeys?: readonly string[];
  readonly musicVolume?: number;
  readonly ambienceVolume?: number;
  readonly fadeInMs?: number;
  readonly fadeOutMs?: number;
}

class SoundscapeRegistry {
  private readonly assets = new Map<string, SoundAssetDefinition>();
  private readonly soundscapes = new Map<string, WorldSoundscapeDefinition>();

  registerAsset(definition: SoundAssetDefinition) {
    this.assets.set(definition.key, definition);
  }

  registerSoundscape(definition: WorldSoundscapeDefinition) {
    this.soundscapes.set(definition.id, definition);
  }

  getAsset(key: string) {
    return this.assets.get(key);
  }

  getSoundscape(id: string) {
    return this.soundscapes.get(id);
  }
}

export const soundscapeRegistry = new SoundscapeRegistry();

// Approved track keys can be added declaratively later without changing
// AudioManager or scene lifecycle code. Empty definitions are silent.
[
  { id: 'home-hub' },
  { id: 'number-kingdom' },
  { id: 'story-forest' },
  { id: 'discovery-lab' },
].forEach(definition => soundscapeRegistry.registerSoundscape(definition));
